<div class="welcome" *ngIf="welcome">
	<div class="welcome-btn">
		<div class="welcome-close" (click)="close()">X</div>
	</div>
	<div class="welcome-img">
		<img src="assets/images/welcome/card_sme_sei.png"/>
	</div>
</div>